var Faq = function () {
	// Helpers
	var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function getPanel(btn) {
		var id = btn.getAttribute('aria-controls');
		return id ? document.getElementById(id) : null;
	}

	function expand(btn, panel) {
		btn.setAttribute('aria-expanded', 'true');

		if (prefersReduce) {
			panel.removeAttribute('hidden');
			panel.style.height = 'auto';
			return;
		}

		// show + animate up
		panel.removeAttribute('hidden');     // must be visible to measure
		panel.style.height = '0px';          // start collapsed
		void panel.offsetHeight;             // reflow
		panel.style.height = panel.scrollHeight + 'px';

		var onEnd = function () {
			panel.style.height = 'auto';       // let it grow with content
			panel.removeEventListener('transitionend', onEnd);
		};
		panel.addEventListener('transitionend', onEnd);
	}

	function collapse(btn, panel) {
		btn.setAttribute('aria-expanded', 'false');

		if (prefersReduce) {
			panel.setAttribute('hidden', '');
			panel.style.height = '0px';
			return;
		}

		// lock current height, then animate down
		panel.style.height = panel.scrollHeight + 'px';
		void panel.offsetHeight;             // reflow
		panel.style.height = '0px';

		var onEnd = function () {
			panel.setAttribute('hidden', '');
			panel.removeEventListener('transitionend', onEnd);
		};
		panel.addEventListener('transitionend', onEnd);
	}

	document.addEventListener('click', function (e) {
		var btn = e.target.closest('.faq__title[aria-controls]');
		if (!btn) return;

		var panel = getPanel(btn);
		if (!panel) return;

		var isExpanded = btn.getAttribute('aria-expanded') === 'true';

		// If opening, close all other open ones first
		if (!isExpanded) {
			var openBtns = document.querySelectorAll('.faq__title[aria-controls][aria-expanded="true"]');
			openBtns.forEach(function (b) {
				if (b === btn) return;
				var p = getPanel(b);
				if (p && !p.hasAttribute('hidden')) collapse(b, p);
				else b.setAttribute('aria-expanded', 'false');
			});
			expand(btn, panel);
		} else {
			collapse(btn, panel);
		}
	});
};

export default Faq;
